import React, { PureComponent } from 'react';

import { activateUserDetailed } from '../actions/app-props';

import { SPECIAL_MENTIONS } from 'utils/editor';

import UserContainer from '../containers/user-container';

const Name = ({ name = '', email = '' }) => {
    if (name && name !== email) {
        return `@${name}`;
    }

    return email;
};

export default class MentionUser extends PureComponent {
    static defaultlProps = {
        clickable: true
    }

    handleClick = () => {
        if (!this.props.clickable) {
            return;
        }

        activateUserDetailed(this.props.id);
    }

    render() {
        if (SPECIAL_MENTIONS.includes(this.props.id)) {
            return <span className="mention">@{ this.props.id }</span>;
        }

        return (
            <span className="mention" onClick={this.handleClick}>
                <UserContainer id={this.props.id}><Name /></UserContainer>
            </span>
        )
    }
}
